import { useTranslation } from 'react-i18next';

export const ChargePointsSiteHeader = (): React.JSX.Element => {
  const { t } = useTranslation();

  return <>{t('delmonicos-shared-sdk.outputs-charge-point.location')}</>;
};
